"use client";

import NoImageFallBack from "@/assets/images/no_image.svg";
import { MediaItem } from "@/common/lib/types";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { getLangFromLocale } from "@/utils/common";
import { combineAltTextWithImageInfo } from "@/utils/product.utils";
// import Image from "next/image";
import { useParams } from "next/navigation";
import { useState } from "react";
import { ImageStyle } from "./ProductCard";
import CldImage from "../ui/cldImg/CldImage";
interface IProps {
  altText: string;
  productImages: MediaItem[];
  productImageStyle?: ImageStyle;
  showProductCarousel?: boolean;
  index?: number;
}
const ProductImage = ({
  productImages,
  productImageStyle,
  showProductCarousel,
  altText,
  index,
}: IProps) => {
  const { locale } = useParams();
  const lang = getLangFromLocale(locale as string);

  // states
  const [imageHovered, setImageHovered] = useState(false);
  const { ref, isIntersecting } = useIntersectionObserver({
    threshold: 0,
    freezeOnceVisible: true,
  });

  //TODO: Quick Fix prefixing images with the CDN URL if the startwith '/'. Correct this later at source
  productImages = productImages.map((image) => {
    if (image.url.startsWith("/")) {
      // image.url = `https://mcdn.magrabi.com/image/upload/c_limit,w_384/f_auto/q_95/v1/p/prod/i${image.url}`;
      image.url = getCloudinaryURL(image.url) ?? NoImageFallBack.src;
    }
    return image;
  });

  return (
    <div
      ref={ref}
      className={cn(
        "relative isolate h-full cursor-pointer",
        showProductCarousel ? "hidden md:flex" : "flex",
      )}
      onPointerEnter={() => setImageHovered(true)}
      onPointerLeave={() => setImageHovered(false)}
    >
      {isIntersecting &&
        (imageHovered && productImages.length > 1 ? (
          <></>
        ) : (
          <div
            className={cn(
              "absolute left-0 top-0 z-[1] flex h-full w-full items-center justify-center bg-tertiary-5",
            )}
          >
            <CldImage
              src={productImages[0]?.url ?? NoImageFallBack.src}
              alt={altText}
              className={cn("h-auto w-full", productImageStyle?.classname, "invert-[2%]")}
              width={productImageStyle?.width || 300}
              height={productImageStyle?.height || 300}
            />
          </div>
        ))}

      {productImages?.length > 1 && (
        <div className="flex h-full w-full items-center justify-center bg-tertiary-5">
          {imageHovered ? (
            <CldImage
              src={productImages[1]?.url ?? NoImageFallBack.src}
              alt={altText}
              className={cn("h-auto w-full invert-[2%]", productImageStyle?.classname)}
              width={productImageStyle?.width || 300}
              height={productImageStyle?.height || 300}
              // priority
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductImage;
